
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    /* eslint-disable no-param-reassign  */
import React from 'react';
import PropTypes from 'prop-types';
import AnchorLink from '@components/AnchorLink';
import { trackClickEvent } from '@utils/analytics';
import { ReactComponent as Star } from '@/src/pages/FactFileIndex/images/star.svg';
import { FACT_FILE_INDEX } from '../../../../constants/routes';
import s from './BackToFactFile.module.scss';
const propTypes = {
    category: PropTypes.string.isRequired,
    analyticsParams: PropTypes.shape({}).isRequired
};
const BackToFactFile = ({ category, analyticsParams }) => {
    const handleClick = () => {
        trackClickEvent({
            destination_url: FACT_FILE_INDEX,
            label: 'Back to all Fact Files',
            location: 'Bottom',
            vertical_index: 3,
            horizontal_index: 0,
            ...analyticsParams
        });
    };
    return (<div data-themed="true" data-testid="BackToFactFileRoot" className={[category, s.root].join(' ')}>
      <hr />
      <AnchorLink href={FACT_FILE_INDEX} onClick={handleClick}>
        <button type="button">
          <div className={[s.star, s.left].join(' ')}>
            <Star />
          </div>
          <span>Back to all Fact Files</span>
          <div className={[s.star, s.right].join(' ')}>
            <Star />
          </div>
        </button>
      </AnchorLink>
    </div>);
};
BackToFactFile.propTypes = propTypes;
export default BackToFactFile;

    async function __Next_Translate__getStaticProps__195ca0caf22__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//FactFile/components/BackToFactFile/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0caf22__ as getStaticProps }
  